import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
type Props = {
  activeLang: 'fr' | 'es' | 'en';
};
export function LanguageBar({
  activeLang
}: Props) {
  const langs: Array<{
    code: 'fr' | 'es' | 'en';
    label: string;
    to: string;
  }> = [{
    code: 'fr',
    label: 'FR',
    to: '/'
  }, {
    code: 'es',
    label: 'ES',
    to: '/es'
  }, {
    code: 'en',
    label: 'EN',
    to: '/en'
  }];
  return <div className="w-full bg-brand-darker flex items-center justify-center h-11 sm:h-12" style={{
    borderBottom: '1px solid rgba(201, 169, 110, 0.3)'
  }} data-id="element-44">
      <nav className="flex items-center" aria-label="Language switcher" data-id="element-45">
        {langs.map((lang, i) => {
        const isActive = lang.code === activeLang;
        return <Fragment key={lang.code} data-id="element-46">
              <Link to={lang.to} className={`font-semibold transition-opacity text-[13px] sm:text-[14px] px-3 sm:px-4 py-2 tracking-[2px] sm:tracking-[3px] ${isActive ? 'text-brand-gold' : 'hover:opacity-100'}`} style={isActive ? {
            borderBottom: '2px solid #C9A96E'
          } : {
            color: '#F9F6F1',
            opacity: 0.7
          }} data-id="element-47">
                {lang.label}
              </Link>
              {i < langs.length - 1 && <span aria-hidden="true" className="text-[13px] sm:text-[14px]" style={{
            color: 'rgba(201, 169, 110, 0.4)'
          }} data-id="element-48">
                  |
                </span>}
            </Fragment>;
      })}
      </nav>
    </div>;
}